export default __webpack_public_path__ + "static/media/49t.c57164ee.jpg";